import { render, staticRenderFns } from "./CollegeList.vue?vue&type=template&id=530c1fd4&scoped=true&"
import script from "./CollegeList.vue?vue&type=script&lang=js&"
export * from "./CollegeList.vue?vue&type=script&lang=js&"
import style0 from "./CollegeList.vue?vue&type=style&index=0&id=530c1fd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530c1fd4",
  null
  
)

export default component.exports